export default __webpack_public_path__ + "media/src/assets/images/MapPinOutboundTransfer-00980aa3af3370c27173f2b6c785baba.svg";